import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OptimizedActionCaller extends Vue {

	readonly actionCallerOptimizingDelayInMs: number = 100

	wrapActionWithAnimationFrameTick(
		callback: () => void,
		actionCallerOptimizingDelayInMs?: number
	): () => void {
		actionCallerOptimizingDelayInMs = actionCallerOptimizingDelayInMs
			|| this.actionCallerOptimizingDelayInMs;

		let ticking: boolean = false;

		const clearTicking = () => ticking = false;

		const optimizedCallback = () => {
			callback();
			setTimeout(clearTicking, actionCallerOptimizingDelayInMs);
		};

		return () => {
			if (!ticking) {
				optimizedCallback();

				ticking = true;
			}
		};
	}

}